<template>
    <div class="position-box">
      <div class="head">
        <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
        <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
      </div>
        <div class="cotainer">
            <h1 class="h1">{{$t('lg.welcome')}}</h1>
            <!-- <h3 class="h3">区块链交易中心</h3> -->
            <div class="tips">{{$t('xgdlmm.zh')}}</div>
            <div class="input-box">
              <input class="input" type="text" v-model="userName" :placeholder="$t('lg.paccount')">
              <img v-if="!theme" v-show="userName" src="@/assets/Log-In_delete.png" class='icon' @click="clear" />
              <img v-else v-show="userName" src="@/assets/theme/close2.png" class='icon' @click="clear" />
            </div>
            <div class="tips">{{$t('xgdlmm.mm')}}</div>
            <div class="input-box input-pwd">
              <input class="input" ref="input" v-model="passwords" type="password" :placeholder="$t('lg.ppwd')">
              <template v-if="isPwd">
                <img v-if="!theme" v-show="passwords" src="@/assets/Log-In_close-eyes.png" class='icon' @click="shpass" />
                <img v-else v-show="passwords" src="@/assets/theme/eyes.png" class='icon' @click="shpass" />
              </template>
               <template v-else>
                <img v-if="!theme" v-show="passwords" src="@/assets/Log-In_eyes.png" class='icon' @click="shpass" />
                <img v-else v-show="passwords" src="@/assets/theme/eyes2.png" class='icon' @click="shpass" />
              </template>
            </div>
            <ul class="item-box">
              <!-- <li class="text t2" v-show="temp_user" @click="create">{{$t('tipsNew.cjxnzh')}}</li> -->
              <router-link tag="li" class="text" to="/forgetPwd">{{$t('lg.ftpwd')}}</router-link>
              <router-link tag="li" class="text" to="/language">{{$t('lg.language')}}</router-link>
            </ul>
            <button class="btn-login btn-bg" @click="login">{{$t('lg.lgs')}}</button>
            <li tag="div" class="t1">{{$t('lg.noaccount')}}<router-link class="t2" tag="span" to="/reg">{{$t('lg.qregister')}}</router-link></li>
        </div>
    </div>
</template>

<script>
export default {
    name: 'login',
    data () {
        return {
            theme: false,
            isPwd: true,
            userName: '',
            passwords: '',
            temp_user: false,
            index: 0
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      localStorage.removeItem('regCheck');
      this.getCheckcode();
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
    },
    methods: {
      back(){
        this.$router.push('/index')
      },
      getCheckcode(){
        let params = {
            token: 1
        }
        this.$ajax.get('/web/reg_checkcode',{params}).then((res) => {
            let resData = res.data.data;
            this.temp_user = resData.temp_user;
        }).catch(function(err){
            console.log(err)
        })
      },
      create(){
        let params = {
              token:1,
          }
          this.$ajax.get('/web/tempLogin',{params}).then((res) => {
            let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  localStorage.setItem('token',resData.data.token);
                  localStorage.removeItem('sbsxbz');
                  localStorage.removeItem('sbsxIcon');
                  setTimeout(() => {
                    this.$router.push('/index')
                  }, 1000)
              }else{
                  this.$toast.center(resData.message);
                  return;
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      clear(){
        this.userName = ''
      },
      // 密码显示或者隐藏
      shpass() {
        if(this.isPwd){
          this.isPwd = false;
          this.$refs.input.type = "text";
        }else{
          this.isPwd = true;
          this.$refs.input.type = "password";
        }
      },
       login(){
            if(!this.userName) {
                this.$toast.center(this.$t('lg.paccount'));
                return false;
            }
            if(!this.passwords) {
                this.$toast.center(this.$t('lg.ppwd'));
                return false;
            }
            if(this.userName.indexOf('@') > 0){
                this.index = 1
            }else{
                this.index = 0
            }
            let params = {
                account: this.userName,
                password: this.passwords,
                index: this.index,
                sms_code: '',
                token: 1
            }
            this.$ajax.post('/web/userLogin',params).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  localStorage.setItem('token',resData.data.token);
                  localStorage.removeItem('sbsxbz');
                  localStorage.removeItem('sbsxIcon');
                  setTimeout(() => {
                    this.$router.push('/index')
                  }, 1000)
              }else{
                  this.$toast.center(resData.message);
                  return;
              }
            }).catch(function(err){
                console.log(err)
            })
       }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .42rem;
        right: .42rem;
        top: 1.6rem;
        bottom: 0;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .h1{
        padding: .8rem 0 .3rem;
        color: #000;
        font-size: .78rem;
    }
    .cotainer .h3{
        color: #9f9f9f;
        font-size: .4rem;
    }
    .cotainer .tips{
        padding-top: .8rem;
        color: #000;
        font-size: .4rem;
    }
    .cotainer .input-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .44rem 0 .38rem;
      border-bottom: .01rem solid #dadada;
    }
    .cotainer .input-box .icon{
      width: .6rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #c5cacd;
        font-size: .4rem;
    }
    .cotainer .input-pwd{
        /* margin-top: 1.3rem; */
    }
    .cotainer .input-box .input{
        width: 100%;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .5rem 0 1.2rem;
        font-size: .4rem;
    }
    .cotainer .btn-login{
        display: block;
        width: 100%;
    }
    .cotainer .t1{
        padding: 1.9rem 0 .4rem;
        color: #acacac;
        font-size: .4rem;
    }
    .cotainer .t2{
        color: #588bf8;
    }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue